import { useQuery, gql } from '@apollo/client'

const GET_LESSON_LOGS = gql`
  query GetLessonLogs($entityId: String!, $entityType: String!) {
    logsActivities(entityId: $entityId, entityType: $entityType) {
        id
        date
        kind
        logBy {
          id
          name
        }
        type
        planId
        userId
        description
        lessonId
    }
  }
`

const useGetLessonLogs = (lessonId) => {
  const { data, loading, error, refetch } = useQuery(GET_LESSON_LOGS, {
    variables: {
      entityId: lessonId,
      entityType: 'lessonId'
    },
    skip: !lessonId,
    fetchPolicy: 'no-cache'
  })

  return {
    logs: data?.logsActivities || [],
    loading,
    error,
    refetch
  }
}

export default useGetLessonLogs
